export const CELL_WRAPPER_CLASS = 'cell-wrapper';
export const CELL_WRAPPER_VALUE_CLASS = `${CELL_WRAPPER_CLASS}--value`;
export const CELL_WRAPPER_ICON_CLASS = `${CELL_WRAPPER_CLASS}--icon`;
